<template>
  <div class="pagination">
    <div class="last" @click="getlastPage"><img class="icon" src="@/assets/icons/icon-last.png" alt="" srcset=""> 上页</div>
    <div class="current">第（<span> {{current}}/{{Math.ceil(this.total/this.size)}}</span>）页</div>
    <div class="next" @click="getNextPage">下页 <img class="icon" src="@/assets/icons/icon-next.png" alt="" srcset=""></div>
    <div class="jump">跳转到 <input type="number" v-model="jumpPage" @keyup.enter="getGivenPage"> 页</div>
    <div class="jump-btn" @click="getGivenPage">跳转</div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: [Number, String],
      default: 12
    },
    curPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      page: 0, // 总页数
      current: 1, // 当前页
      jumpPage: '' // 指定页数
    }
  },
  created () {
    this.current = this.curPage
  },
  watch: {
    curPage (n, o) {
      this.current = n
    },
    total(n) {
      if(n==0) {
        this.current = 0
      } else {
        this.current = this.curPage
      }
    }
  },
  methods: {
    getlastPage () {
      if (this.current <= 1) {
        return
      }
      this.jumpPage = ''
      this.$emit('change', --this.current)
    },
    getNextPage () {
      if (this.current >= Math.ceil(this.total / this.size)) {
        return
      }
      this.jumpPage = ''
      this.$emit('change', ++this.current)
    },
    getGivenPage () {
      if (!this.jumpPage) {
        return
      }
      if (parseInt(this.jumpPage) === this.current) {
        return
      }
      if (parseInt(this.jumpPage) >= Math.ceil(this.total / this.size)) {
        this.jumpPage = Math.ceil(this.total / this.size)
      }
      if (parseInt(this.jumpPage) < 1) {
        this.jumpPage = 1
      }
      this.current = this.jumpPage
      this.$emit('change', this.current)
    }
  }
}
</script>

<style lang='less' scoped>
.pagination {
  margin: 30px 0;
  text-align: center;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  font-size: 15px;
  div {
    display: inline-block;
  }
  .icon {
    width: 10px;
    height: 10px;
  }
  .last, .next, .jump-btn {
    width: 54px;
    height: 22px;
    border: 1px solid #999;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    margin: 0 20px;

  }
  .jump-btn {
    border: 1px solid #dc2e4c;
  }
  .current {
    span {
      color: #dc2e4c;
    }
  }
  .jump {
    input {
      width: 40px;
      height: 20px;
      text-align: center;
      outline: none;
    }
  }
  .jump-btn {
    background-color: #dc2e4c;
    color: #fff;
  }
}
</style>
